module.exports = __webpack_public_path__ + "static/RobotoMono-Regular-a48ac41620cd818c5020d0f4302489ff.ttf";